export default {
  sync: {
    position: 'absolute',
    bottom: 10,
    left: 0,
    zIndex: 9999,
    padding: 5,
    opacity: 0.5,
  },
  border: {
    height: '10px',
    width: '100%',
    display: 'block',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Sidebar/styles.js